import * as Yup from "yup";

export const flowValidationSchema = Yup.object({
    name: Yup.string().required("Required field").max(100),
    description: Yup.string(),
    moduleId: Yup.number().required("Required field"),
    typeId: Yup.number().required("Required field"),
    ownerUser: Yup.object().required("Required field"),
    enabled: Yup.boolean(),
    allowAutoMode: Yup.boolean(),
    allowManualMode: Yup.boolean(),
    allowRestart: Yup.boolean(),
    allowAssigneesReassign: Yup.boolean(),
});

const dueDateCalculationValidation = (values) => (value, context) => {
    if (!values.dueUnit || !values.dueUnitQty) return false;
    return true;
};

export const taskValidationSchema = Yup.lazy((values) =>
    Yup.object({
        name: Yup.string().required("Required field").max(100),
        description: Yup.string(),
        initialStatus: Yup.string()
            .required("Required field")
            .test(
                "is-valid-status",
                "Invalid status. If the 'Wait for previous task' option is true, the initial status has to be TO DO",
                (value, context) => {
                    if (value === "todo") {
                        return true;
                    } else {
                        if (Boolean(values.waitForPreviousTask)) {
                            return false;
                        }
                        return true;
                    }
                }
            ),
        defaultAssigneeUser: Yup.object().nullable().notRequired(),
        dueUnitQty:
            values.dueUnit || Boolean(values.notifyBeforeDueDate)
                ? Yup.number()
                      .nullable()
                      .integer("Decimals are not allowed here")
                      .positive("A positive number is required")
                      .min(1, "The interval must be greater than or equal to 1")
                      .required("Required field")
                : Yup.number().nullable(),
        dueUnit:
            values.dueUnitQty || Boolean(values.notifyBeforeDueDate) ? Yup.string().required("Required field") : Yup.string().nullable(),
        allowAssigneeReassign: Yup.boolean(),
        waitForPreviousTask: Yup.boolean().notRequired().nullable(),
        notifyClientOnClose: Yup.boolean().notRequired().nullable(),
        notifyBeforeDueDate: Yup.boolean().notRequired().nullable(),
        notifyBeforeDueDateInterval: Boolean(values.notifyBeforeDueDate)
            ? Yup.number()
                  .nullable()
                  .integer("Decimals are not allowed here")
                  .positive("A positive number is required")
                  .min(1, "The interval must be greater than or equal to 1")
                  .required("Required field")
                  .test("is-due-date-calculation-valid", "Due Date Calculation values are required", dueDateCalculationValidation(values))
            : Yup.number().nullable(),
        notifyBeforeDueDateTimeUnit: Boolean(values.notifyBeforeDueDate)
            ? Yup.string()
                  .nullable()
                  .required("Required field")
                  .test("is-due-date-calculation-valid", "Due Date Calculation values are required", dueDateCalculationValidation(values))
            : Yup.string().nullable(),
    })
);
